import React from 'react'
import {Flex, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import Checkbox from '../../checkbox'
import PropTypes from 'prop-types'

const RecipeFilterModalTile = ({option, fieldUID, isChecked = false, setTempSelectedFilters}) => {
    const handleFilterSelection = ({fieldUID, option}) => {
        setTempSelectedFilters((prev) => {
            const currentValues = prev[fieldUID] || []
            const exists = currentValues.some((item) => item.contentstackValue === option)

            let updatedValues
            if (exists) {
                updatedValues = currentValues.filter((item) => item.contentstackValue !== option)
            } else {
                updatedValues = [...currentValues, {contentstackValue: option}]
            }

            return {
                ...prev,
                [fieldUID]: updatedValues,
            }
        })
    }
    return (
        <Flex w="100%" paddingBottom="small.base">
            <Flex w="100%" justifyContent="space-between" alignItems="center">
                <Text textStyle="body.small" fontWeight="normal">
                    {option?.contentstackValue}
                </Text>
                <Checkbox
                    isChecked={isChecked}
                    onChange={() => {
                        handleFilterSelection({
                            fieldUID,
                            option: option?.contentstackValue,
                        })
                    }}
                />
            </Flex>
        </Flex>
    )
}

RecipeFilterModalTile.propTypes = {
    option: PropTypes.object,
    fieldUID: PropTypes.string,
    isChecked: PropTypes.bool,
    setTempSelectedFilters: PropTypes.func,
}
export default RecipeFilterModalTile
